var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip_box"},[_c('span',{staticClass:"icon_succ",class:{'icon_fail':_vm.status == '0'}}),_c('p',{staticClass:"pay_succ"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }